type SessionCache<T> = {
    readonly get: () => T | undefined;
    readonly set: (value: T) => T;
    readonly reset: () => void;
}

type Cache<T> = { ttl: number, value: T }

export default function SessionCache<T>(ttl: number): SessionCache<T>{
    const initialState: Cache<T> = { ttl: 0, value: null as never };
    const state: Cache<T> = { ...initialState };

    function get(): T | undefined {
        const { ttl, value } = state;
        return ttl > Date.now() ? value : undefined;
    }

    function reset(): void {
        Object.assign(state, initialState);
    }

    function set(value: T): T {
        return Object.assign(state, {
            ttl: Date.now() + ttl,
            value,
        }).value;
    }

    return Object.freeze({ get, reset, set });
}

export const SECONDS = 1000;
export const MINUTES = 60 * SECONDS;
export const HOURS = 60 * MINUTES;
